export default "__VITE_ASSET__2b31151f__"